export const DO_GET_ACCOUNT = 'DO_GET_ACCOUNT';
export const DO_GET_ACCOUNTS = 'DO_GET_ACCOUNTS';
export const DO_UPDATE_ACCOUNT = 'DO_UPDATE_ACCOUNT';

export const DO_CREATE_ARTICLE = 'DO_CREATE_ARTICLE';
export const DO_DELETE_ARTICLE = 'DO_DELETE_ARTICLE';
export const DO_GET_ARTICLE = 'DO_GET_ARTICLE';
export const DO_SEARCH_ARTICLES = 'DO_SEARCH_ARTICLES';
export const DO_UPDATE_ARTICLE = 'DO_UPDATE_ARTICLE';

export const DO_CREATE_BELIEF_STATEMENT = 'DO_CREATE_BELIEF_STATEMENT';
export const DO_DELETE_BELIEF_STATEMENT = 'DO_DELETE_BELIEF_STATEMENT';
export const DO_GET_BELIEF_STATEMENT = 'DO_GET_BELIEF_STATEMENT';
export const DO_GET_BELIEF_STATEMENTS = 'DO_GET_BELIEF_STATEMENTS';
export const DO_UPDATE_BELIEF_STATEMENT = 'DO_UPDATE_BELIEF_STATEMENT';

export const DO_LOGIN = 'DO_LOGIN';
export const DO_LOGOUT = 'DO_LOGOUT';
export const DO_SET_TOKEN = 'DO_SET_TOKEN';

export const DO_GET_CHANNEL = 'DO_GET_CHANNEL';
export const DO_CREATE_CHANNEL = 'DO_CREATE_CHANNEL';
export const DO_GET_CHANNELS = 'DO_GET_CHANNELS';
export const DO_SEARCH_CHANNELS = 'DO_SEARCH_CHANNELS';
export const DO_UPDATE_CHANNEL = 'DO_UPDATE_CHANNEL';

export const DO_ADD_EPISODE_TO_COLLECTION = 'DO_ADD_EPISODE_TO_COLLECTION';
export const DO_DELETE_COLLECTION = 'DO_DELETE_COLLECTION';
export const DO_GET_COLLECTION = 'DO_GET_COLLECTION';
export const DO_GET_EPISODES_FOR_COLLECTION = 'DO_GET_EPISODES_FOR_COLLECTION';
export const DO_CREATE_COLLECTION = 'DO_CREATE_COLLECTION';
export const DO_DELETE_EPISODE_FROM_COLLECTION = 'DO_DELETE_EPISODE_FROM_COLLECTION';
export const DO_GET_COLLECTIONS = 'DO_GET_COLLECTIONS';
export const DO_SEARCH_COLLECTIONS = 'DO_SEARCH_COLLECTIONS';
export const DO_UPDATE_COLLECTION = 'DO_UPDATE_COLLECTION';

export const DO_CREATE_EPISODE = 'DO_CREATE_EPISODE';
export const DO_DELETE_EPISODE = 'DO_DELETE_EPISODE';
export const DO_GET_EPISODE = 'DO_GET_EPISODE';
export const DO_GET_EPISODES = 'DO_GET_EPISODES';
export const DO_SEARCH_EPISODES = 'DO_SEARCH_EPISODES';
export const DO_UPDATE_EPISODE = 'DO_UPDATE_EPISODE';

export const DO_CREATE_EVENT = 'DO_CREATE_EVENT';
export const DO_DELETE_EVENT = 'DO_DELETE_EVENT';
export const DO_DELETE_EVENT_ORDERS = 'DO_DELETE_EVENT_ORDERS';
export const DO_DUPLICATE_EVENT = 'DO_DUPLICATE_EVENT';
export const DO_GET_EVENT = 'DO_GET_EVENT';
export const DO_GET_EVENTS = 'DO_GET_EVENTS';
export const DO_OVERRIDE_EVENT = 'DO_OVERRIDE_EVENT';
export const DO_SEARCH_EVENTS = 'DO_SEARCH_EVENTS';
export const DO_UPDATE_EVENT = 'DO_UPDATE_EVENT';
export const DO_UPDATE_EVENT_FIELD = 'DO_UPDATE_EVENT_FIELD';

export const DO_CREATE_EVENT_CONTACT = 'DO_CREATE_EVENT_CONTACT';
export const DO_DELETE_EVENT_CONTACT = 'DO_DELETE_EVENT_CONTACT';
export const DO_GET_EVENT_CONTACT = 'DO_GET_EVENT_CONTACT';
export const DO_UPDATE_EVENT_CONTACT = 'DO_UPDATE_EVENT_CONTACT';

export const DO_CREATE_EVENT_PACKAGE = 'DO_CREATE_EVENT_PACKAGE';
export const DO_DELETE_EVENT_PACKAGE = 'DO_DELETE_EVENT_PACKAGE';
export const DO_UPDATE_EVENT_PACKAGE = 'DO_UPDATE_EVENT_PACKAGE';

export const DO_DELETE_EVENT_REGISTRATION = 'DO_DELETE_EVENT_REGISTRATION';
export const DO_DELETE_EVENT_REGISTRATIONS = 'DO_DELETE_EVENT_REGISTRATIONS';
export const DO_GET_EVENT_REGISTRATION = 'DO_GET_EVENT_REGISTRATION';
export const DO_GET_EVENT_REGISTRATIONS = 'DO_GET_EVENT_REGISTRATIONS';

export const DO_GET_FORM = 'DO_GET_FORM';
export const DO_CREATE_FORM = 'DO_CREATE_FORM';

export const DO_CREATE_FORM_BLOCK = 'DO_CREATE_FORM_BLOCK';
export const DO_OVERRIDE_FORM_BLOCK = 'DO_OVERRIDE_FORM_BLOCK';
export const DO_UPDATE_FORM_BLOCK = 'DO_UPDATE_FORM_BLOCK';
export const DO_DELETE_FORM_BLOCK = 'DO_DELETE_FORM_BLOCK';
export const DO_DELETE_FORM_BLOCKS = 'DO_DELETE_FORM_BLOCKS';

export const DO_CREATE_FORM_FIELD = 'DO_CREATE_FORM_FIELD';
export const DO_GET_FORM_FIELD = 'DO_GET_FORM_FIELD';
export const DO_OVERRIDE_FORM_FIELD = 'DO_OVERRIDE_FORM_FIELD';
export const DO_UPDATE_FORM_FIELD = 'DO_UPDATE_FORM_FIELD';
export const DO_DELETE_FORM_FIELD = 'DO_DELETE_FORM_FIELD';

export const DO_CREATE_LOCATION = 'DO_CREATE_LOCATION';
export const DO_GET_LOCATIONS = 'DO_GET_LOCATIONS';
export const DO_UPDATE_LOCATION = 'DO_UPDATE_LOCATION';

export const DO_CREATE_MEDIA_IMAGE = 'DO_CREATE_MEDIA_IMAGE';
export const DO_CREATE_MEDIA_VIDEO = 'DO_CREATE_MEDIA_VIDEO';
export const DO_DELETE_MEDIA = 'DO_DELETE_MEDIA';

export const DO_CREATE_MEMBER = 'DO_CREATE_MEMBER';
export const DO_GET_MEMBER = 'DO_GET_MEMBER';
export const DO_SEARCH_MEMBERS = 'DO_SEARCH_MEMBERS';
export const DO_UPDATE_MEMBER = 'DO_UPDATE_MEMBER';

export const DO_CREATE_MINISTRY = 'DO_CREATE_MINISTRY';
export const DO_DELETE_MINISTRY = 'DO_DELETE_MINISTRY';
export const DO_GET_MINISTRY = 'DO_GET_MINISTRY';
export const DO_GET_MINISTRIES = 'DO_GET_MINISTRIES';
export const DO_UPDATE_MINISTRY = 'DO_UPDATE_MINISTRY';

export const DO_CREATE_MINISTRY_ROLE = 'DO_CREATE_MINISTRY_ROLE';
export const DO_DELETE_MINISTRY_ROLE = 'DO_DELETE_MINISTRY_ROLE';
export const DO_UPDATE_MINISTRY_ROLE = 'DO_UPDATE_MINISTRY_ROLE';

export const DO_CREATE_ORDER = 'DO_CREATE_ORDER';
export const DO_GET_ORDER = 'DO_GET_ORDER';

export const DO_GET_PAGE = 'DO_GET_PAGE';
export const DO_GET_PAGES = 'DO_GET_PAGES';
export const DO_UPDATE_PAGE = 'DO_UPDATE_PAGE';

export const DO_CREATE_USER = 'DO_CREATE_USER';
export const DO_GET_USER = 'DO_GET_USER';
export const DO_GET_USERS = 'DO_GET_USERS';
export const DO_SEARCH_USERS = 'DO_SEARCH_USERS';
export const DO_GET_AUTHENTICATED_USER = 'DO_GET_AUTHENTICATED_USER';
export const DO_UPDATE_USER = 'DO_UPDATE_USER';

export const DO_CREATE_SERVICE = 'DO_CREATE_SERVICE';
export const DO_DELETE_SERVICE = 'DO_DELETE_SERVICE';
export const DO_GET_SERVICE = 'DO_GET_SERVICE';
export const DO_GET_SERVICES = 'DO_GET_SERVICES';
export const DO_UPDATE_SERVICE = 'DO_UPDATE_SERVICE';

export const DO_CREATE_STAFF_MEMBER = 'DO_CREATE_STAFF_MEMBER';
export const DO_DELETE_STAFF_MEMBER = 'DO_DELETE_STAFF_MEMBER';
export const DO_GET_STAFF_MEMBER = 'DO_GET_STAFF_MEMBER';
export const DO_GET_STAFF_MEMBERS = 'DO_GET_STAFF_MEMBERS';
export const DO_UPDATE_STAFF_MEMBER = 'DO_UPDATE_STAFF_MEMBER';

export const DO_CREATE_SPEAKER = 'DO_CREATE_SPEAKER';
export const DO_GET_SPEAKER = 'DO_GET_SPEAKER';
export const DO_SEARCH_SPEAKERS = 'DO_SEARCH_SPEAKERS';
export const DO_UPDATE_SPEAKER = 'DO_UPDATE_SPEAKER';

export const DO_CREATE_TAG = 'DO_CREATE_TAG';

export const DO_CREATE_WAIVER = 'DO_CREATE_WAIVER';
export const DO_DELETE_WAIVER = 'DO_DELETE_WAIVER';
export const DO_GET_WAIVER = 'DO_GET_WAIVER';
export const DO_GET_WAIVERS = 'DO_GET_WAIVERS';
export const DO_UPDATE_WAIVER = 'DO_UPDATE_WAIVER';



// WEBPACK FOOTER //
// ./src/store/types/actions.js